'use client'

import { useState } from 'react'
import { Spacer } from '@vinted/web-ui'
import classNames from 'classnames'

import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'

import { SeparatedList } from '@marketplace-web/common-components/separated-list-ui'
import { VasEntryPoint } from '@marketplace-web/vas/vas-data'

import ClosetPromotionCheckout from '../ClosetPromotion/ClosetPromotionCheckout'
import useVasEntryPointsContext from '../../containers/VasEntryPointsProvider/useVasEntryPointsContext'
import ClosetPromotionBanner from './ClosetPromotionBanner'
import BumpBanner from './BumpBanner'
import BumpAgainSuggestionDialog from '../BumpAgainSuggestionDialog'
import useFetchBumpAgainSuggestion from './hooks/useFetchBumpAgainSuggestion'

const ProfileVasBanners = () => {
  const breakpoints = useBreakpoint()

  const { vasEntryPoints } = useVasEntryPointsContext()
  const { showBumpAgainSuggestion, soldItemId } = useFetchBumpAgainSuggestion()

  const [isPrecheckoutOpen, setIsPrecheckoutOpen] = useState(false)

  function handlePrecheckoutOpen() {
    setIsPrecheckoutOpen(true)
  }

  function handlePrecheckoutClose() {
    setIsPrecheckoutOpen(false)
  }

  function renderSeparator() {
    return breakpoints.phones ? (
      <Spacer orientation="horizontal" size="medium" />
    ) : (
      <Spacer orientation="vertical" size="x-large" />
    )
  }

  const isPromotedClosetsCheckoutEntryPointAvailable = vasEntryPoints?.some(
    entryPoint => entryPoint.name === VasEntryPoint.ProfilePromotedClosets,
  )

  const promotedClosetsBanner = vasEntryPoints?.find(
    entryPoint =>
      entryPoint.name === VasEntryPoint.ProfilePromotedClosets ||
      entryPoint.name === VasEntryPoint.PromotedClosetsStats,
  )

  const bumpBanner = vasEntryPoints?.find(entryPoint => entryPoint.name === VasEntryPoint.Bumps)

  return (
    <>
      <div className={classNames({ 'u-flexbox': breakpoints.tabletsUp })}>
        <SeparatedList separator={renderSeparator()}>
          {bumpBanner && <BumpBanner bumpBanner={bumpBanner} />}
          {promotedClosetsBanner && (
            <ClosetPromotionBanner
              promotedClosetsBanner={promotedClosetsBanner}
              handlePrecheckoutOpen={handlePrecheckoutOpen}
            />
          )}
        </SeparatedList>
      </div>
      {isPromotedClosetsCheckoutEntryPointAvailable && (
        <ClosetPromotionCheckout
          isOpen={isPrecheckoutOpen}
          handlePrecheckoutClose={handlePrecheckoutClose}
        />
      )}
      {showBumpAgainSuggestion && soldItemId && (
        <BumpAgainSuggestionDialog
          soldItemId={soldItemId}
          singleBumpableItemId={bumpBanner?.selectedItemId}
        />
      )}
    </>
  )
}

export default ProfileVasBanners
